// 过程性自考管理系统路由
export default [
  // 首页路由重定向
  {
    path: "/",
    redirect: "/selfExam/home"
  },
  // 首页
  {
    path: "/selfExam/home",
    name: "selfExam",
    component: () => import("@/pages_selfExam/home/index"),
    meta: {
      title: "首页"
    }
  },
  // 课程列表
  {
    path: "/selfExam/course",
    name: "selfExamCourse",
    component: () => import("@/pages_selfExam/course/index"),
    meta: {
      title: "我的课程"
    }
  },
  // 课程详情
  {
    path: "/selfExam/courseDetail",
    name: "selfExamCourseDetail",
    component: () => import("@/pages_selfExam/courseDetail/index"),
    meta: {
      title: "课程详情"
    }
  },
  // 考试报名
  {
    path: "/selfExam/exam",
    name: "selfExamExam",
    component: () => import("@/pages_selfExam/exam/index"),
    meta: {
      title: "考试报名"
    }
  },
  // 在线作业
  {
    path: "/selfExam/homework",
    name: "selfExamHomework",
    component: () => import("@/pages_selfExam/homework/index"),
    meta: {
      title: "在线作业"
    }
  },
  // 成绩查询
  {
    path: "/selfExam/grades",
    name: "selfExamGrades",
    component: () => import("@/pages_selfExam/grades/index"),
    meta: {
      title: "成绩查询"
    }
  },
  // 个人中心
  {
    path: "/selfExam/account",
    name: "selfExamAccount",
    component: () => import("@/pages_selfExam/account/index"),
    meta: {
      title: "个人中心"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/selfExam.js